module.exports = __webpack_public_path__ + "assets/e72b22e2ca53b733916917d24cd36164.svg";